import React, { Component, Fragment, memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typo, HR, Icon as _Icon } from 'tmt-ui-kit';
import memoize from 'lodash/memoize';

import colors from '../../../../utils/colors';

const Icon = styled(_Icon)`
  color: #e36b25;
  font-weight: 600 !important;
  font-size: 20px !important;
  line-height: 1.57;
  display: flex;
  align-items: center;
`;

const priceConditionInfo = {
  transport: 'Transportation fares are included.',
  ticket: 'Admission fees are included.',
  food: 'Meals are included.',
};

const Header = styled(Typo.HeaderTwo)`
  margin: 8px 0px 8px !important;
  line-height: 1.57;
`;

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  flex: wrap;
`;

const IconContainer = styled.div`
  @media (max-width: 700px) {
    cursor: pointer;
    user-select: none;
    display: inline-block !important;
    vertical-align: top !important;
    white-space: normal !important;
  }
  display: flex;
  align-self: flex-end;
  margin-right: 4px;
  ${props => !props.enabled && 'color: #eaf2f5;'}
`;

const ConditionDetail = styled(Typo.Paragraph)`
  margin: 0 !important;
  color: ${colors.web5Dark} !important;
  font-size: 15px !important;
  @media (max-width: 320px) {
    font-size: 15px !important;
  }
`;

const Content = styled(Typo.Paragraph)`
  margin: 0px;
`;

const sortedFunction = memoize(
  (priceCondition) => {
    if (!Array.isArray(priceCondition.detail_traveler)) {
      return [];
    }
    return [
      priceCondition.detail_traveler.find(a => a.icon === 'transport'),
      priceCondition.detail_traveler.find(a => a.icon === 'ticket'),
      priceCondition.detail_traveler.find(a => a.icon === 'food')
    ].filter(condition => !!condition);
  },
  (priceCondition) => (Array.isArray(priceCondition.enabled_icons) ? priceCondition.enabled_icons.join(',') : '')
);

const PriceConditionInfo = memo(
  props => {
    const { trip, isShowInfo } = props;
    const { price_condition: priceCondition } = trip;
    const sortedDetail = sortedFunction(priceCondition !== null && priceCondition !== undefined ? priceCondition : {});
    return (
      <Fragment>
        <Header>Price Conditions</Header>
        {sortedDetail
          .map((condition, index) => (
            <Fragment key={condition.icon}>
              <ItemContainer key={`condition-${index}`}>
                <IconContainer enabled={condition.enabled}>
                  <Icon name="check" />
                </IconContainer>
                <ConditionDetail>
                  {condition.text}
                </ConditionDetail>
              </ItemContainer>
              {isShowInfo && (
                <Fragment>
                  <Content>{priceConditionInfo[condition.icon]}</Content>
                  {index !== sortedDetail.length - 1 && <HR />}
                </Fragment>
              )}
            </Fragment>
          ))
        }
      </Fragment>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.trip._id !== nextProps.trip._id) {
      return false;
    }
    return true;
  }
);

PriceConditionInfo.propTypes = {
  trip: PropTypes.object,
  isShowInfo: PropTypes.bool
};

class PriceCondition extends Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.trip._id !== this.props.trip._id) {
      return true;
    }
    return false;
  }

  render() {
    const { trip } = this.props;
    return (
      <PriceConditionInfo trip={trip} />
    );
  }
}

PriceCondition.propTypes = {
  trip: PropTypes.object,
};

export default PriceCondition;
